var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3104 10.9881V14.109C19.3104 15.2126 18.872 16.271 18.0917 17.0514C17.3113 17.8318 16.2529 18.2702 15.1493 18.2702H4.74633C3.64272 18.2702 2.58431 17.8318 1.80394 17.0514C1.02357 16.271 0.585159 15.2126 0.585159 14.109V11.6123C0.585159 11.4468 0.650921 11.288 0.767976 11.171C0.885032 11.0539 1.04379 10.9881 1.20934 10.9881H19.3104ZM19.3104 10.9881V4.74638C19.3104 3.64277 18.872 2.58436 18.0917 1.80398C17.3113 1.02361 16.2529 0.585205 15.1493 0.585205H9.9478M14.109 18.2702L15.1493 20.3508M5.78662 18.2702L4.74633 20.3508",
    stroke: "#232020",
    strokeWidth: 1.17033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4848 5.78667H6.41078C6.06644 5.78667 5.79076 5.50787 5.82821 5.16457C5.98009 3.78411 6.68437 0.585205 9.94777 0.585205C13.2112 0.585205 13.9154 3.78411 14.0673 5.16457C14.1048 5.50787 13.8291 5.78667 13.4848 5.78667Z",
    stroke: "#232020",
    strokeWidth: 1.17033,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon02);
export default __webpack_public_path__ + "static/media/icon02.ba677ee37d3a62f121b3663969df46c9.svg";
export { ForwardRef as ReactComponent };